import React__default, { useState } from 'react';
import { Chip } from '@mui/material';
import { styled } from '@mui/material/styles';
import clsx from 'clsx';

var PREFIX = "Tag";
var classes = {
    root: "".concat(PREFIX, "-root")
};
var StyledTag = styled(Chip, {
    shouldForwardProp: function (prop) {
        return prop !== "backgroundColor" &&
            prop !== "textColor" &&
            prop !== "fontSize" &&
            prop !== "padding" &&
            prop !== "marginTop" &&
            prop !== "marginRight" &&
            prop !== "marginBottom" &&
            prop !== "marginLeft" &&
            prop !== "borderRadius" &&
            prop !== "otherTags";
    }
})(function (_a) {
    var theme = _a.theme, backgroundColor = _a.backgroundColor, textColor = _a.textColor, fontSize = _a.fontSize, padding = _a.padding, marginTop = _a.marginTop, marginRight = _a.marginRight, marginBottom = _a.marginBottom, marginLeft = _a.marginLeft, borderRadius = _a.borderRadius, configurationMode = _a.configurationMode;
    return ({
        maxWidth: configurationMode ? "90%" : "95%",
        backgroundColor: isDefined(backgroundColor) ? "".concat(backgroundColor) : theme.palette.primary.main,
        color: getLabelColor(textColor, theme),
        fontSize: isDefined(fontSize) ? "".concat(fontSize, "rem") : "0.8rem",
        padding: isDefined(padding) ? "".concat(padding, "px") : "5px",
        marginTop: isDefined(marginTop) ? "".concat(marginTop, "px") : theme.spacing(0.6),
        marginRight: isDefined(marginRight) ? "".concat(marginRight, "px") : theme.spacing(0.6),
        marginBottom: isDefined(marginBottom) ? "".concat(marginBottom, "px") : theme.spacing(0.6),
        marginLeft: isDefined(marginLeft) ? "".concat(marginLeft, "px") : theme.spacing(0.6),
        borderRadius: isDefined(borderRadius) ? "".concat(borderRadius, "px") : "4px",
        cursor: configurationMode ? "pointer" : "inherit",
        "& .MuiChip-label": {
            padding: 0,
            overflow: "hidden",
            textOverflow: "ellipsis",
            color: getLabelColor(textColor, theme)
        }
    });
});
/**
 *
 * @param confParameter the value received from the admin
 * @returns true if the parameter has been defined by the user
 */
var isDefined = function (confParameter) {
    return confParameter !== undefined;
};
var getLabelColor = function (textColor, theme) {
    return isDefined(textColor) ? "".concat(textColor) : theme.palette.common.white;
};
var Tag = function Tag(_a) {
    var title = _a.title, titleOnHover = _a.titleOnHover, backgroundColor = _a.backgroundColor, textColor = _a.textColor, borderRadius = _a.borderRadius, fontSize = _a.fontSize, marginBottom = _a.marginBottom, marginLeft = _a.marginLeft, marginRight = _a.marginRight, marginTop = _a.marginTop, padding = _a.padding, dateTargetNumber = _a.dateTargetNumber, dateTargetUnit = _a.dateTargetUnit, dateTargetMode = _a.dateTargetMode, fieldInternalName = _a.fieldInternalName, className = _a.className, titleMinimized = _a.titleMinimized, displayOtherTagsCount = _a.displayOtherTagsCount, _b = _a.configurationMode, configurationMode = _b === void 0 ? false : _b;
    var _c = useState(false), isHover = _c[0], setIsHover = _c[1];
    var handleMouseEnter = function () { return setIsHover(true); };
    var handleMouseLeave = function () { return setIsHover(false); };
    return (React__default.createElement(StyledTag, { backgroundColor: backgroundColor, borderRadius: borderRadius, fontSize: fontSize, marginBottom: marginBottom, marginLeft: marginLeft, marginRight: marginRight, marginTop: marginTop, padding: padding, className: clsx("Tag", classes.root, className), size: "small", label: getAdaptedLabel(title, isHover, titleMinimized, displayOtherTagsCount), textColor: textColor, title: titleOnHover || title, "aria-label": title, "data-date-target-number": dateTargetNumber, "data-date-target-unit": dateTargetUnit, "data-date-target-mode": dateTargetMode, "data-field-internal-name": fieldInternalName, configurationMode: configurationMode, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave }));
};
var getAdaptedLabel = function (originalLabel, isHover, titleMinimized, displayOtherTagsCount) {
    // we don't want to minimize the title : return original label
    if (!titleMinimized) {
        return originalLabel;
    }
    // case of displaying the count of other tags : return original label
    if (displayOtherTagsCount) {
        return originalLabel;
    }
    var firstLetter = originalLabel.length > 1 ? originalLabel.substring(0, 1) : originalLabel;
    return isHover ? originalLabel : firstLetter;
};

export { Tag as default };
//# sourceMappingURL=index.js.map
